import CodeHighlighter from './code-highlighter';

export default CodeHighlighter;
